import { useCallback, useState } from 'react';
import Axios from '@/utils/Axios';
import { getUrlAPI } from '@/utils/Path';

export default function useApiUpdate(url: string) {
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const handleUpdate = useCallback(
    async (data: any) => {
      try {
        setLoading(true);
        const res = await Axios.put(getUrlAPI(url), data);
        setData(res.data);
        return res.data;
      } catch (error: any) {
        setError(error);
      }
    },
    [url]
  );

  return { data, error, loading, handleUpdate };
}

// update demo
// const { data, error, loading, handleUpdate } = useApiUpdate('https://NRCT/seed/1');
// const body = {};
// handleUpdate(body);
